import { useAppContext } from '@context/app/AppContext';
import { CartItem } from '@reducer/cartReducer';
import { useSession } from 'next-auth/react';
import Link from 'next/link';
import router from 'next/router';
import React, { Fragment, useEffect, useState } from 'react';
import Box from '../components/Box';
import Button from '../components/buttons/Button';
import { Card1 } from '../components/Card1';
import Divider from '../components/Divider';
import FlexBox from '../components/FlexBox';
import Grid from '../components/grid/Grid';
import CheckoutNavLayout from '../components/layout/CheckoutNavLayout';
import ProductCard7 from '../components/product-cards/ProductCard7';
import Select from '../components/Select';
import TextField from '../components/text-field/TextField';
import TextArea from '../components/textarea/TextArea';
import Typography from '../components/Typography';
import countryList from '../data/countryList';
import { CartApi } from './api';

const Cart = () => {
  const { state, dispatch } = useAppContext();
  const cartList: CartItem[] = state.cart.cartList;
  const { data: session, status } = useSession();
 const loading = status === 'loading';;
  const [totalDelivery, setTotalDelivery] = useState(0);
  const token = session?.accessToken.toString();
  const [cartItems, setCartItems] = useState(null);

  useEffect(() => {
    if (!loading) {
      getUserCart();
    }
  }, [loading]);

  const getUserCart = async () => {
    try {
      const res = await CartApi.getCart(token);
      const { data } = res;
      setCartItems(data);
      console.log('DATA CARt MAIN', data);

      data.forEach((item) => {
        const { quantity, title, actualPrice, price, imageLink, stock, id } = item;
        dispatch({
          type: 'CHANGE_CART_AMOUNT',
          payload: {
            id,
            stock,
            name: title,
            qty: quantity,
            price: actualPrice,
            imgUrl: { fileUrl: imageLink },
          },
        });
        setTotalDelivery((delivery) => delivery + item.deliveryCost);
      });
    } catch (err) {
      console.log('ERROR getting user cart', err);
    }
  };

  const proceedToDetails = async () => {
    // check if the items have been increased or decreased
    let updateCart = false;
    cartItems.forEach((item) => {
      cartList.forEach((cartList) => {
        if (item.id === cartList.id) {
          if (cartList.qty !== item.subTotal / parseInt(item.price)) {
            console.log('The Quantity has been changed for this item', item.id, cartList.qty);
            updateCart = true;
          }
        }
      });
    });

    if (updateCart) {
      await updateCartItems();
      await getUserCart();
    }

    const bindingIds = cartItems.map((item) => {
      return item.bindingId;
    });
    router.push({
      pathname: `/checkout`,
      query: { bindingIds },
    });
  };

  const updateCartItems = async () => {
    cartList.forEach(async (item) => {
      try {
        const response = await CartApi.addToCart(token, item.id, item.qty);
        console.log('cart updated successfully', response);
      } catch (error) {
        console.log('error in adding item to cart');
      }
    });
  };

  const getTotalPrice = () => {
    return cartList.reduce((accumulator, item) => accumulator + item.price * item.qty, 0) || 0;
  };

  return (
    <Fragment>
      <Grid container spacing={6}>
        <Grid item lg={8} md={8} xs={12}>
          {cartList.map((item) => (
            <ProductCard7 id={item.id} key={item.id} mb="1.5rem" {...item} />
          ))}
        </Grid>
        <Grid item lg={4} md={4} xs={12}>
          <Card1>
            <FlexBox justifyContent="space-between" alignItems="center" mb="1rem">
              <Typography color="gray.600">Sub Total:</Typography>
              <FlexBox alignItems="flex-end">
                <Typography fontSize="18px" fontWeight="600" lineHeight="1">
                  MYR{getTotalPrice().toFixed(2)}
                </Typography>
                <Typography fontWeight="600" fontSize="14px" lineHeight="1">
                  00
                </Typography>
              </FlexBox>
            </FlexBox>

            <FlexBox justifyContent="space-between" alignItems="center" mb="1rem">
              <Typography color="gray.600">Shipping Total:</Typography>
              <FlexBox alignItems="flex-end">
                <Typography fontSize="18px" fontWeight="600" lineHeight="1">
                  MYR{totalDelivery}
                </Typography>
                <Typography fontWeight="600" fontSize="14px" lineHeight="1">
                  00
                </Typography>
              </FlexBox>
            </FlexBox>

            <Button
              variant="outlined"
              color="primary"
              my="1rem"
              fullwidth
              onClick={proceedToDetails}
            >
              Next - Delivery Details
            </Button>
          </Card1>
        </Grid>
      </Grid>
    </Fragment>
  );
};

Cart.layout = CheckoutNavLayout;

export default Cart;
